import { createSelector } from '@reduxjs/toolkit';
import unionBy from 'lodash/unionBy';

export const selectTopics = state => state.topics;

export const isLoadingSelectTopics = state => state.topics.isLoading;

export const selectTopicsCategoriesUnion = createSelector([state => state.topics.categories], categories => {
  if (!categories) return categories;

  const shared = categories.filter(category => category.sharing).map(category => ({ ...category, ids: [category.id] }));

  const local = categories
    .filter(category => !category.sharing)
    .map(category => {
      const ids = [category.id];
      const sameName = shared.find(data => data.name === category.name);
      if (sameName) {
        ids.push(sameName.id);
      }
      return { ...category, ids };
    });

  return unionBy([...local, ...shared], 'name');
});
